import { EmailAttachment } from '@/api/submission-scheduler/email-attachments';
import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';

export const columns: ColumnDef<EmailAttachment>[] = [
	{
		id: 'select',
		header: ({ table }) => (
			<div className="mr-1 flex justify-center">
				<Checkbox
					checked={table.getIsAllPageRowsSelected()}
					onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
					aria-label="Select all"
				/>
			</div>
		),
		cell: ({ row }) => (
			<div className="mr-4 flex justify-center">
				<Checkbox
					checked={row.getIsSelected()}
					onCheckedChange={(value) => row.toggleSelected(!!value)}
					aria-label="Select row"
				/>
			</div>
		),
		enableSorting: false,
		enableHiding: false,
	},
	{
		accessorKey: 'fileName',
		header: () => <div className="p-6">Filename</div>,
		cell: ({ row }) => (
			<div className="p-2 font-medium">{row.original.fileName}</div>
		),
	},
];
